import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

//將 App 組件渲染到 HTML 元素中，該元素的 ID 是 "root"
ReactDOM.render(<App />, document.getElementById("root"));
